
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extensions/dagster",
      function () {
        return require("private-next-pages/extensions/dagster.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extensions/dagster"])
      });
    }
  